import React from "react";
import "./SuccessionSaleBanner.css";

const SuccessionSaleBanner = ({ openModal }) => {
    return (
        <div className="succession-banner-container">
            <img src="/bijoux.PNG" alt="Bijoux anciens" className="banner-image" />
            <div className="banner-content">
                <p className="banner-subheading">FAITES NOUS CONFIANCE POUR VOS SUCCESSIONS</p>
                <h2 className="title">NE LAISSEZ PLUS VOS TRÉSORS PRENDRE LA POUSSIÈRE</h2>
                <p className="banner-text">
                    Faites de la place dans votre maison et gagnez de l'argent en revendant vos meubles et objets anciens chez nous !
                </p>
                <button className="banner-button" onClick={openModal}>
                    Demandez votre estimation &gt;&gt;
                </button>
            </div>
        </div>
    );
};

export default SuccessionSaleBanner;
